<script setup>
import { computed, onBeforeUnmount, onMounted, onUpdated, ref } from 'vue'
import { useRoute } from 'vue-router'
import { usePageGuide } from '@/composables/usePageGuide'
import { isPanelHelpRoute } from '@/utils/panelHelp'

defineOptions({ inheritAttrs: false })
const props = defineProps({
  label: { type: String, default: 'راهنما' },
  fallbackTag: { type: String, default: 'span' },
  withinControl: Boolean,
})
const route = useRoute()
const guide = usePageGuide()
const isPanel = computed(() => isPanelHelpRoute(route.path))
const content = ref(null)
const entryId = Symbol('pageHelpSection')
const updateSection = () => {
  if (!isPanel.value) { guide?.remove(entryId); return }
  const text = content.value?.textContent?.replace(/\s+/g, ' ').trim() || ''
  guide?.set(entryId, { path: route.path, title: props.label === 'راهنما' ? '' : props.label, text })
}
onMounted(updateSection)
onUpdated(updateSection)
onBeforeUnmount(() => guide?.remove(entryId))
</script>

<template>
  <span v-if="isPanel" ref="content" hidden aria-hidden="true"><slot /></span>
  <component :is="fallbackTag" v-else v-bind="$attrs"><slot /></component>
</template>
